// NOTE needs to be updated since some of them are deprecated
import {
  Injectable, Injector,
  ViewContainerRef, NgModuleFactory,
  Compiler, Type, ComponentFactoryResolver, NgModuleRef, createNgModuleRef
} from '@angular/core';
import { StorageService } from './storage.service';
import { SmallLazyLoadingService } from './small-lazy-loading.service';

interface LazyLoadedModule {
  path: string;
  providerName: string;
}

@Injectable({
  providedIn: 'root'
})
export class LazyLoadingService {
  private lazyLoadedModuleSetupMap: Map<string, LazyLoadedModule>;
  private lazyLoadedModuleRefMap: Map<string, NgModuleRef<any>>;
  private appComponentContainerRef: ViewContainerRef;
  private mainContainerRef: ViewContainerRef;
  private homeContainerRef: ViewContainerRef;
  private pdfContainerRef: ViewContainerRef;
  // private readingContainerRef: ViewContainerRef;
  // private pdfReadingContainerRef: ViewContainerRef;
  // private textReadingContainerRef: ViewContainerRef;

  constructor(
    // private readonly ngModuleFactoryLoader: NgModuleFactoryLoader,
    private readonly injector: Injector,
    private readonly compiler: Compiler,
    private smallLazyLoadingService: SmallLazyLoadingService
  ) {
    this.lazyLoadedModuleSetupMap = new Map<string, LazyLoadedModule>();
    this.lazyLoadedModuleRefMap = new Map<string, NgModuleRef<any>>();
    this.initiateLazyLoadedModuleMap();
  }

  private isInclude(name, isScript) {
    let names = name.split('/');
    if (names.length > 0) {
      name = names[names.length - 1];
    }
    let es = document.getElementsByTagName(isScript ? 'script' : 'link');
    for (let i = 0; i < es.length; i++)
      if (typeof (es[i][isScript ? 'src' : 'href']) !== 'undefined') {
        if (es[i][isScript ? 'src' : 'href'].indexOf(name) != -1) return true;
      }
    return false;
  }


  public loadScript(_url: string) {
    return new Promise((resolve, reject) => {
      if (this.isInclude(_url, true)) {
        resolve(null);
      } else {
        var element = document.createElement("script");
        var parent = 'body';
        element.type = "text/javascript";
        element.src = _url;
        element.async = true;
        element.onload = function() {
          console.log("loadedScript", _url);
          resolve(null);
        };
        element.onerror = function(err) {
          console.log("err loadScript", err);
          reject(err);
        };
        document[parent].appendChild(element);
      }
    });
  }

  public getLazyLoadedModule(moduleName: string): NgModuleRef<any> {
    console.log("getLazyLoadedModule", this.lazyLoadedModuleRefMap);
    return this.lazyLoadedModuleRefMap.get(moduleName);
  }

  public loadCSS(_url: string) {
    return new Promise((resolve, reject) => {
      if (this.isInclude(_url, false)) {
        resolve(null);
      } else {
        var element = document.createElement("link");
        var parent = 'body';
        element.rel = "stylesheet";
        element.type = "text/css";
        element.href = _url;
        element.onload = function() {
          resolve(null);
        };
        element.onerror = function() {
          reject();
        };
        document[parent].appendChild(element);
      }
    });
  }

  // need to add modules that have to be lazy loaded here
  private initiateLazyLoadedModuleMap() {
    const lazyLoadedReaderInitial: LazyLoadedModule = {
      path: 'src/app/modules-2022/lazy-loaded/reader-initial/reader-initial.module#ReaderInitialModule',
      providerName: 'UserMenuContainerComponent'
    };
    // const lazyLoadedAccountModule: LazyLoadedModule = {
    //   path: 'src/app/modules-2022/lazy-loaded/account/account.module#AccountModule',
    //   providerName: 'AccountContainerComponent'
    // };

    const lazyLoadedAppInitial: LazyLoadedModule = {
      path: 'src/app/modules-2022/lazy-loaded/app-initial/app-initial.module#AppInitialModule',
      providerName: 'AppInitialComponent'
    };
    const lazyLoadedFileViewer: LazyLoadedModule = {
      path: 'src/app/modules-2022/lazy-loaded/pdf-reader/file.module#FileModule',
      providerName: 'FileViewerProvidedComponent'
    };
    const lazyLoadedConvert: LazyLoadedModule = {
      path: 'src/app/modules-2022/lazy-loaded/reader-initial/components/convert/convert.module#ConvertModule',
      providerName: 'ConvertDialogComponent'
    };
    const lazyLoadedTextProcessing: LazyLoadedModule = {
      path: 'src/app/modules-2022/lazy-loaded/text-processing/text-processing.module#TextProcessingModule',
      providerName: ''
    };
    const lazyLoadedXRegExp: LazyLoadedModule = {
      path: 'src/app/modules-2022/lazy-loaded/pdf-reader/xregexp.module#XRegExpModule',
      providerName: ''
    };
    const lazyLoadedAmplify: LazyLoadedModule = {
      path: '../modules-2022/lazy-loaded/amplify/amplify.module',
      providerName: ''
    };
    const LoginModule: LazyLoadedModule = {
      path: 'src/app/modules-2022/lazy-loaded/login-dev/login.module#LoginModule',
      providerName: 'LoginComponent'
    };
    const lazyLoadedPwPaymentModule: LazyLoadedModule = {
      path: 'src/app/modules-2022/lazy-loaded/pw-payment/pw-payment.module#PwPaymentModule',
      providerName: 'PwPaymentModule'
    };
    const lazyLoadedBugReport: LazyLoadedModule = {
      path: 'src/app/modules-2022/lazy-loaded/bug-report/bug-report.module#BugReportModule',
      providerName: 'BugReportComponent'
    };
    const lazyLoadedWavesurfer: LazyLoadedModule = {
      path: 'src/app/modules-2022/lazy-loaded/reader-initial/wavesurfer.module#WavesurferModule',
      providerName: ''
    };
    const lazyLoadedTextReader: LazyLoadedModule = {
      path: 'src/app/modules-2022/lazy-loaded/text-reader/text-reader.module#TextReaderModule',
      providerName: ''
    };
    const lazyLoadedPdfReader: LazyLoadedModule = {
      path: 'src/app/modules-2022/lazy-loaded/pdf-reader/pdf-reader.module#PdfReaderModule',
      providerName: ''
    };

    this.lazyLoadedModuleSetupMap.set('FileModule', lazyLoadedFileViewer);
    this.lazyLoadedModuleSetupMap.set('ReaderInitialModule', lazyLoadedReaderInitial);
    // this.lazyLoadedModuleSetupMap.set('AccountModule', lazyLoadedAccountModule);
    this.lazyLoadedModuleSetupMap.set('AppInitialModule', lazyLoadedAppInitial);
    this.lazyLoadedModuleSetupMap.set('ConvertModule', lazyLoadedConvert);
    this.lazyLoadedModuleSetupMap.set('TextProcessingModule', lazyLoadedTextProcessing);
    this.lazyLoadedModuleSetupMap.set('XRegExpModule', lazyLoadedXRegExp);
    this.lazyLoadedModuleSetupMap.set('AmplifyModule', lazyLoadedAmplify);
    this.lazyLoadedModuleSetupMap.set('LoginModule', LoginModule);
    this.lazyLoadedModuleSetupMap.set('BugReportModule', lazyLoadedBugReport);
    this.lazyLoadedModuleSetupMap.set('WavesurferModule', lazyLoadedWavesurfer);
    this.lazyLoadedModuleSetupMap.set('PwPaymentModule', lazyLoadedPwPaymentModule);
    this.lazyLoadedModuleSetupMap.set('ReaderInitialModule', lazyLoadedReaderInitial);
    this.lazyLoadedModuleSetupMap.set('TextReaderModule', lazyLoadedTextReader);
    this.lazyLoadedModuleSetupMap.set('PdfReaderModule', lazyLoadedPdfReader);
  }

  public setHomeContainerRef(homeContainerRef: ViewContainerRef) {
    this.homeContainerRef = homeContainerRef;
  }

  public setAppComponentContainerRef(appComponentContainerRef: ViewContainerRef) {
    console.log('setAppComponentContainerRef ')
    this.appComponentContainerRef = appComponentContainerRef;
  }

  public setPdfContainerRef(pdfContainerRef: ViewContainerRef) {
    this.pdfContainerRef = pdfContainerRef;
  }

  // public setReadingContainerRef(readingContainerRef: ViewContainerRef) {
  //   this.readingContainerRef = readingContainerRef;
  // }

  // public setTextReadingContainerRef(textReadingContainerRef: ViewContainerRef) {
  //   this.textReadingContainerRef = textReadingContainerRef;
  // }
  // public setPdfReadingContainerRef(pdfReadingContainerRef: ViewContainerRef) {
  //   this.pdfReadingContainerRef = pdfReadingContainerRef;
  // }

  public checkModuleLoaded(moduleClassName: string) {
    if (window['loaded_modules'] && window['loaded_modules'][moduleClassName]) {
      console.log("loaded_modules true", window['loaded_modules']);
      return true;
    }
    console.log("false");
    return false;
  }

  public static addModuleToLoadedModuleList(moduleClassName: string) {
    if (!window['loaded_modules']) { window['loaded_modules'] = {}; }
    window['loaded_modules'][moduleClassName] = true;
  }

  public createLazyModule(key: string, lazyLoadedModule, compToLoad = '', container = this.smallLazyLoadingService.mainContainerRef) {
    // console.log("createLazyModule", lazyLoadedModule);
    // console.log('lazyLoadedModule compToLoad ', compToLoad, container)
    return new Promise(resolve => {
      (lazyLoadedModule() as Promise<NgModuleFactory<any> | Type<any>>)
        .then(elementModuleOrFactory => {
          if (elementModuleOrFactory instanceof NgModuleFactory) {
            // if ViewEngine
            return elementModuleOrFactory;
          } else {
            try {
              // if Ivy
              return this.compiler.compileModuleAsync(elementModuleOrFactory);
            } catch (err) {
              throw err;
            }
          }
        })
        .then(moduleFactory => {
          try {
            const elementModuleRef = moduleFactory.create(this.injector);
            this.lazyLoadedModuleRefMap.set(key, elementModuleRef);
            if (!compToLoad || compToLoad.length == 0) {
              return resolve(true);
            }
            // const moduleInstance = elementModuleRef.instance;
            // const componentFactory = elementModuleRef.instance.resolveComponent();
            const providedComponent = elementModuleRef.injector.get(compToLoad)
            // const componentFactory = this.cfr.resolveComponentFactory(providedComponent);
            const componentFactory = elementModuleRef.componentFactoryResolver.resolveComponentFactory(providedComponent)
            // console.log('moduleFactory providedComponent ', providedComponent)
            // console.log('moduleFactory ', componentFactory)
            if (!container) {
              return resolve(true);
            }
            // console.log('moduleFactory addLazyComponentToDom', container, componentFactory)
            return this.addLazyComponentToDom(container, componentFactory, elementModuleRef)
              .then(componentRef => {
                // console.log('addLazyComponentToDom ', container, componentFactory)
                resolve(componentRef);
              })
          } catch (err) {
            console.log('err ', err)
            resolve(false)
          }
        })
        .catch(err => {
          console.log('err ', err)
        })
    })
  }

  public async loadConvertModule() {
    const module = 'ConvertModule';
    if (this.lazyLoadedModuleSetupMap.has(module) && this.checkModuleLoaded(module)) {
      console.log('loadConvertModule loaded')
      return Promise.resolve(true);
    }
    const providerName = this.lazyLoadedModuleSetupMap.get(module).providerName;
    return this.createLazyModule('ConvertModule', () =>
      import('../modules-2022/lazy-loaded/reader-initial/components/convert/convert.module')
        .then(m => m.ConvertModule)
        .catch(err => {
          console.log('loadConvertModule import err ', err);
        })
      , providerName, null);
  }

  // public async loadAccountModule() {
  //   const module = 'AccountModule';
  //   if (this.lazyLoadedModuleSetupMap.has(module) && this.checkModuleLoaded(module)) {
  //     console.log('loadAccountModule loaded')
  //     return Promise.resolve(true);
  //   }
  //   const providerName = this.lazyLoadedModuleSetupMap.get(module).providerName;
  //   return this.createLazyModule('AccountModule', () =>
  //     import('../modules-2022/lazy-loaded/account/account.module')
  //       .then(m => m.AccountModule)
  //       .catch(err => {
  //         console.log('loadAccountModule import err ', err);
  //       })
  //     , providerName, this.homeContainerRef);
  // }

  public async loadAmplifyModule() {
    const module = 'AmplifyModule';
    if (this.lazyLoadedModuleSetupMap.has(module) && this.checkModuleLoaded(module)) {
      console.log('loadAmplifyModule loaded')
      return Promise.resolve(true);
    }
    return this.createLazyModule('AmplifyModule', () =>
      import('../modules-2022/lazy-loaded/amplify/amplify.module')
        .then(m => m.AmplifyModule)
        .catch(err => {
          console.log('loadAmplifyModule import err ', err);
        }));
  }

  public async loadTextProcessingModule() {
    const module = 'TextProcessingModule';
    if (this.lazyLoadedModuleSetupMap.has(module) && this.checkModuleLoaded(module)) {
      console.log('loadTextProcessingModule loaded')
      return Promise.resolve(true);
    }
    const providerName = this.lazyLoadedModuleSetupMap.get(module).providerName;
    return this.createLazyModule('TextProcessingModule', () =>
      import('../modules-2022/lazy-loaded/text-processing/text-processing.module')
        .then(m => m.TextProcessingModule)
        .catch(err => {
          console.log('getAuth import err ', err);
        })
      , providerName);
  }

  public async loadXRegExpModule() {
    const module = 'XRegExpModule';
    if (this.lazyLoadedModuleSetupMap.has(module) && this.checkModuleLoaded(module)) {
      console.log('loadXRegExpModuleModule loaded')
      return Promise.resolve(true);
    }
    const providerName = this.lazyLoadedModuleSetupMap.get(module).providerName;
    return this.createLazyModule('XRegExpModule', () =>
      import('../modules-2022/lazy-loaded/pdf-reader/xregexp.module')
        .then(m => m.XRegExpModule)
        .catch(err => {
          console.log('loadXRegExpModule err ', err);
        })
      , providerName);
  }

  public async loadLoginModule(): Promise<any> {
    const module = 'LoginModule';
    if (this.lazyLoadedModuleSetupMap.has(module) && this.checkModuleLoaded(module)) {
      console.log('loadLoginModule loaded')
      return Promise.resolve(true);
    }
    const providerName = this.lazyLoadedModuleSetupMap.get(module).providerName;
    console.log('providerName ', providerName)
    return this.createLazyModule('LoginModule', () =>
      import('../modules-2022/lazy-loaded/login-dev/login.module')
        .then(m => m.LoginModule)
        .catch(err => {
          console.log('loadLoginModule import err ', err);
        })
      , providerName, this.homeContainerRef);
  }

  public async loadReaderInitialModule() {
    const module = 'ReaderInitialModule';
    if (this.lazyLoadedModuleSetupMap.has(module) && this.checkModuleLoaded(module)) {
      return Promise.resolve(true);
    }
    // TODO
    const providerName = this.lazyLoadedModuleSetupMap.get(module).providerName;
    return this.createLazyModule('ReaderInitialModule', () =>
      import('../modules-2022/lazy-loaded/reader-initial/reader-initial.module')
        .then(m => m.ReaderInitialModule)
        .catch(err => {
          console.log('loadReaderInitialModule import err ', err);
        })
      , providerName, this.homeContainerRef);
  }

  public async loadFileModule() {
    const module = 'FileModule';
    if (this.lazyLoadedModuleSetupMap.has(module) && this.checkModuleLoaded(module)) {
      console.log('loadFileModule loaded')
      return Promise.resolve(true);
    }
    const providerName = this.lazyLoadedModuleSetupMap.get(module).providerName;
    return this.createLazyModule('FileModule', () =>
      import('../modules-2022/lazy-loaded/pdf-reader/file.module')
        .then(m => m.FileModule)
        .catch(err => {
          console.log('loadFileModule import err ', err);
        })
      , providerName, this.homeContainerRef);
  }

  public async loadFile2022Module() {
    const module = 'FileModule';
    if (this.lazyLoadedModuleSetupMap.has(module) && this.checkModuleLoaded(module)) {
      console.log('loadFileModule loaded')
      return Promise.resolve(true);
    }
    const providerName = this.lazyLoadedModuleSetupMap.get(module).providerName;
    return this.createLazyModule('FileModule', () =>
      import('../modules-2022/lazy-loaded/pdf-reader/file.module')
        .then(m => m.FileModule)
        .catch(err => {
          console.log('loadFileModule import err ', err);
        })
      , providerName, this.pdfContainerRef);
  }

  public async loadPwPaymentModule(): Promise<any> {
    const module = 'PwPaymentModule';
    if (this.lazyLoadedModuleSetupMap.has(module) && this.checkModuleLoaded(module)) {
      console.log('loadPwPaymentModule loaded');
      return Promise.resolve(true);
    }
    // TODO
    // const providerName = this.lazyLoadedModuleSetupMap.get(module).providerName;
    // return this.createLazyModule('PwPaymentModule', () =>
    //   import('../modules-2022/lazy-loaded/pw-payment/pw-payment.module')
    //     .then(m => m.PwPaymentModule)
    //     .catch(err => {
    //       console.log('loadPwPaymentModule import err ', err);
    //     })
    //   , providerName, this.homeContainerRef);
  }

  public async loadBugReportModule(): Promise<any> {
    const module = 'BugReportModule';
    if (this.lazyLoadedModuleSetupMap.has(module) && this.checkModuleLoaded(module)) {
      console.log('loadBugReportModule loaded');
      return Promise.resolve(true);
    }
    const providerName = this.lazyLoadedModuleSetupMap.get(module).providerName;
    console.log('providerName ', providerName)
    return this.createLazyModule('BugReportModule', () =>
      import('../modules-2022/lazy-loaded/bug-report/bug-report.module')
        .then(m => m.BugReportModule)
        .catch(err => {
          console.log('loadBugReportModule import err ', err);
        })
      , providerName);
  }

  public async loadWavesurferModule() {
    const module = 'WavesurferModule';
    if (this.lazyLoadedModuleSetupMap.has(module) && this.checkModuleLoaded(module)) {
      console.log('loadWavesurferModule loaded')
      return Promise.resolve(true);
    }
    // TODO
    const providerName = this.lazyLoadedModuleSetupMap.get(module).providerName;
    return this.createLazyModule('WavesurferModule', () =>
      import('../modules-2022/lazy-loaded/reader-initial/wavesurfer.module')
        .then(m => m.WavesurferModule)
        .catch(err => {
          console.log('loadWavesurferModule err ', err);
        })
      , providerName);
  }

  public async loadTextReaderModule() {
    console.log("loadTextReaderModule");
    const module = 'TextReaderModule';
    if (this.lazyLoadedModuleSetupMap.has(module) && this.checkModuleLoaded(module)) {
      console.log('loadTextReaderModule loaded')
      return Promise.resolve(true);
    }
    const providerName = this.lazyLoadedModuleSetupMap.get(module).providerName;
    return this.createLazyModule('TextReaderModule', () =>
      import('../modules-2022/lazy-loaded/text-reader/text-reader.module')
        .then(m => m.TextReaderModule)
        .catch(err => {
          console.log('loadTextReaderModule import err ', err);
        })
      , providerName);
  }

  public async loadPdfReaderModule() {
    console.log("loadPdfReaderModule");
    const module = 'PdfReaderModule';
    if (this.lazyLoadedModuleSetupMap.has(module) && this.checkModuleLoaded(module)) {
      console.log('loadPdfReaderModule loaded')
      return Promise.resolve(true);
    }
    const providerName = this.lazyLoadedModuleSetupMap.get(module).providerName;
    return this.createLazyModule('PdfReaderModule', () =>
      import('../modules-2022/lazy-loaded/pdf-reader/pdf-reader.module')
        .then(m => m.PdfReaderModule)
        .catch(err => {
          console.log('loadPdfReaderModule import err ', err);
        })
      , providerName);
  }

  public addLazyComponentToDom(viewContainerRef, componentFactory, elementModuleRef = null): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        // TODO
        // viewContainerRef.clear();
        let newComponentRef;
        if (elementModuleRef) {
          newComponentRef = viewContainerRef.createComponent(componentFactory, 0, this.injector, { ngModuleRef: elementModuleRef });
        }
        // const newComponentRef = viewContainerRef.createComponent(componentFactory, 0, this.injector, {ngModuleRef: elementModuleRef});
        resolve(newComponentRef);
      } catch (err) {
        console.log('addLazyComponentToDom err ', err)
        reject(err);
      }
    })
  }

  public loadExternalStyle(styleUrl: string) {
    return new Promise((resolve, reject) => {
      const styleElement = document.createElement('link');
      styleElement.href = styleUrl;
      styleElement.onload = resolve;
      document.head.appendChild(styleElement);
    });
  }

  public loadExternalScript(scriptUrl: string) {
    return new Promise(resolve => {
      const scriptEle = document.getElementById(scriptUrl);
      console.log(scriptEle);
      if (scriptEle == null) {
        const scriptElement = document.createElement('script');
        scriptElement.id = scriptUrl;
        scriptElement.src = scriptUrl;
        scriptElement.onload = resolve;
        document.body.appendChild(scriptElement);
      } else {
        resolve(true);
      }
    });
  }

  public loadIntercomScript() {
    return new Promise(resolve => {
      const intercomStr = "window.intercomSettings = {app_id: 'vccymf6u'}; function messenger(display) { Intercom(display); return (true)};(function(){var w=window;var ic=w.Intercom;if(typeof ic===\"function\"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/vccymf6u';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();"
      const scriptElement = document.createElement('script');
      scriptElement.innerHTML = intercomStr;
      document.body.appendChild(scriptElement);
      (<any>window).messenger('show');
      resolve;
    });
  }

  public async loadAppInitialModule(): Promise<any> {
    const module = 'AppInitialModule';
    if (this.lazyLoadedModuleSetupMap.has(module) && this.checkModuleLoaded(module)) {
      console.log('loadAppInitialModule loaded')
      return Promise.resolve(true);
    }
    const providerName = this.lazyLoadedModuleSetupMap.get(module).providerName;
    return this.createLazyModule('AppInitialModule', () =>
      import('../modules-2022/lazy-loaded/app-initial/app-initial.module')
        .then(m => m.AppInitialModule)
        .catch(err => {
          console.log('loadAppInitialModule import err ', err);
        })
      , providerName, this.homeContainerRef);
  }

  public loadGtagScript() {
    console.log('gtag: loading...');
    return new Promise(resolve => {
      this.loadExternalScript("https://www.googletagmanager.com/gtag/js?id=G-CW9Z1LWZ31").then(res => {
        console.log('gtag str...');
        const gtagStr = "window.dataLayer = window.dataLayer || []; function gtag() {dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-CW9Z1LWZ31');"
        const scriptElement = document.createElement('script');
        scriptElement.innerHTML = gtagStr;
        document.body.appendChild(scriptElement);
        resolve;
      })
    });
  }

  loadFonts() {
    // this.loadCSS("https://fonts.gstatic.com");
    this.loadCSS("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&amp;display=swap");
    this.loadCSS("https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500&amp;display=swap");
  }

  public async createLazyComponent(componentName: string, viewContainerRef = this.appComponentContainerRef) {
    // if (!viewContainerRef || !componentPath || componentPath.length == 0)
    //   return Promise.resolve(null);
    // const lazyLoadedComponentPath = this.lazyLoadedModuleSetupMap.get(componentName).path;
    // console.log('lazyLoadedComponentPath ', lazyLoadedComponentPath)
    // const component = await import('../modules-2022/lazy-loaded/login-dev/components/login.component');
    // const lazyLoadedComponent = this.cfr.resolveComponentFactory(component);
    // const {instance} = this.quizContainer.createComponent(quizCardFactory, null, this.injector);
    // return this.createLazyComponentFactory(module)
    //   .then(componentFactory => {
    //     return this.addLazyComponentToDom(viewContainerRef, componentFactory);
    //   })
    //   .catch(_ => {
    //     return Promise.resolve(null);
    //   });
  }

  // public createLazyComponentFactory(module: string): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     if (this.lazyLoadedModuleSetupMap.has(module) && !this.checkModuleLoaded(module)) {
  //       const lazyLoadedModulePath = this.lazyLoadedModuleSetupMap.get(module).path;
  //       const providerName = this.lazyLoadedModuleSetupMap.get(module).providerName;

  //       this.ngModuleFactoryLoader.load(lazyLoadedModulePath)
  //         .then(factory => {
  //           const moduleRef = factory.create(this.injector);
  //           const componentType = moduleRef.injector.get(providerName);
  //           const componentFactory = moduleRef.componentFactoryResolver.resolveComponentFactory(componentType);
  //           resolve(componentFactory);
  //         });
  //     } else {
  //       reject();
  //     }
  //   });
  // }
}
